import { render, staticRenderFns } from "./Addemand.vue?vue&type=template&id=4030ddd3&scoped=true"
import script from "./Addemand.vue?vue&type=script&lang=js"
export * from "./Addemand.vue?vue&type=script&lang=js"
import style0 from "./Addemand.vue?vue&type=style&index=0&id=4030ddd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4030ddd3",
  null
  
)

export default component.exports